<template>
  <div id="IndexSIVAC_div">

    <menusuperior titulo="SIVAC" subtitulo="Sistema de Verificación de Asistencia y Caja"></menusuperior>
    <menuizquierda></menuizquierda>

    <div v-if="$route.fullPath == RUTA_RAIZ_SISTEMA">
      <bienvenidaSistemas :Sistema="'SIVAC'"></bienvenidaSistemas>
    </div>

    <div v-show="$route.fullPath != RUTA_RAIZ_SISTEMA" class="content-area">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>

  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/Comunes/MenuIzquierdaDeLosSistemas.vue'
  import bienvenidaSistemas from '@/components/Tablero/BienvenidaSistemas.vue';
  import comun from '@/../static/js/comun'

  export default {
    name: 'Plantilla',
    components: {
      menusuperior: menusuperior,
      menuizquierda: menuizquierda,
      bienvenidaSistemas: bienvenidaSistemas
    },
    data() {
      return {
        RUTA_RAIZ_SISTEMA: '/SIVAC'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/SIVAC/Comun/Plantilla.vue